<template>
	<div class="cmp-wrapper">
		<basic-container>
			<el-form inline :model="formData" ref="subjectCompanyManage">
        <h2>门店详情</h2>
				<el-form-item label="门店名称">
          <fuzzy-query
            ref="cusOption2"
            :valueId.sync="storeId1"
            typeKey="storeName"
            :option="cusOption2"
          ></fuzzy-query>
        </el-form-item>
        <el-form-item label="门店ID" prop="storeId2">
          <el-input type="number" style="margin-left: 10px;" v-model="storeId2" placeholder="请输入门店ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon" @click="handleSearch" type="primary" style="margin-left: 10px;">查询</el-button>
          <el-button icon="el-icon" @click="handleBind" type="primary" style="margin-left: 10px;">新增</el-button>
          <el-button icon="el-icon" @click="handleUnbind" type="primary" style="margin-left: 10px;">删除</el-button>
        </el-form-item>
        
			</el-form>
      <el-table v-loading="loading" :data="tableData" ref="bingCompanyTable">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="门店ID" prop="companyId" align="center"></el-table-column>
        <el-table-column label="门店名称" prop="companyName" align="center"></el-table-column>
      </el-table>
      <div class="footer pager">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="formData.pageNumber"
          :page-size.sync="formData.pageSize"
          :page-sizes="[20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          :total.sync="total"
          background
        ></el-pagination>
      </div>
      <div class="footer">
        <el-button size="mini" @click="handleBack">返回</el-button>
      </div>
		</basic-container>
	</div>
</template>
<script>
	export default{
		data(){
			return {
        storeId1: "",
        storeId2: "",
        tableData: [],
        storeId: "",
				formData: {
					subjectId: "",
					companyId: "",
          companyIds: [],
          pageNumber: 1,
          pageSize: 20
				},
        total: 0,
        loading: false
			}
		},

    created() {
      this.formData.subjectId=this.$route.query.subjectId;
      this.search();
    },

    beforeRouteEnter(to, from, next) {
      next(async vm => {
        try {
          vm.formData.subjectId = vm.$route.query.subjectId;
          vm.search();
        } catch (error) {
          console.log(error);
          next();
        }
        
      })
    },
    beforeRouteLeave(to, from, next) {
      this.formData.subjectId="";
      this.$refs.subjectCompanyManage.resetFields(); 
      next();
    },

    watch: {
      "storeId1":{
        handler: function(val){
          this.formData.companyId=val;
        }
      },
      "storeId2":{
        handler: function(val){
          this.formData.companyId=val;
        }
      }
    },

    methods: {
      handleBack() {
        this.$router.go(-1);
      },

      handleSearch(){
        this.search();
      },

      handleBind(){
        this.bind();
      },

      handleUnbind(){
        this.unbind();
      },

      search(){
        this.formData.pageNumber = 1;
        this.getList();
      },

      async getList() {
        this.loading = true;
        const {
          data: { items, totalCount }
        } = await _api.splitAcc.listCompany(this.formData);
        if (items) {
          this.tableData = items || [];
          this.total = totalCount;
        }
        this.loading = false;
      },

      handleSizeChange(val) {
        this.formData.pageNumber = 1;
        this.getList();
      },
      handleCurrentChange(val){
        this.getList();
      },

      async bind(){
        const{
          ret,
          data
        } = await _api.splitAcc.bindCompany(this.formData);
        if(ret && data){
          this.$message({
          type: "success",
          message: "绑定成功"
        });
        }
      },
      async unbind(){
        const storeRows = this.$refs.bingCompanyTable.selection;
            if (!storeRows || storeRows.length === 0) {
                this.$message.warning("至少选择一个门店");
                return;
            }
            this.$confirm('确定解绑吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async() => {
                try {
                    this.loading = true;
                    const { ret, error } = await _api.splitAcc.unbindCompany({
                        companyIds: storeRows.map(item => item.companyId),
                        subjectId: this.formData.subjectId
                    });
                    if (ret) {
                      this.search();
                    } else {
                        this.$message.warning(error);
                    }
                } catch (e) {
                    console.log(e);
                    this.$message.error(e);
                } finally {
                    this.loading = false;
                }
            }).catch(() => {
            });
      }
    }
	}

</script>